import React, { useContext, useEffect, useRef, useState } from "react";
import useDebounce from "../useDebounce";
import "./CityDropdownForTrip.css";
import { UserContext } from "context";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import UniqueId from "../UniqueId";
import { RxCross2 } from "react-icons/rx";
import FirmImg from '../../../assets/img/firm.png'


const CityDropdownForTrip = ({
    label = "",
    fetchData,
    onChange,
    selectedItem = null,
    pageSize = 10,
    disabled = false,
    error = false,
    errorMessage = "",
    isAddButton = false,
    addButtonAction = (e) => { },
    withState = true,
    placeholder,
    inputClass,
    isClearOption = false,
    isClearHandleChange = () => { }
}) => {
    const {
        masterData,
    } = useContext(UserContext);
    const [search, setSearch] = useState("");
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [items, setItems] = useState([]);
    const [displayedItems, setDisplayedItems] = useState([]);
    const [page, setPage] = useState(1);
    const [hasMore, setHasMore] = useState(true);
    const [isLoadingMore, setIsLoadingMore] = useState(false);
    const [selected, setSelected] = useState(selectedItem);
    const [isInitialLoad, setIsInitialLoad] = useState(true);
    const [lastFetchedQuery, setLastFetchedQuery] = useState(null);
    const debouncedSearch = useDebounce((search).trim(), 500);
    const containerRef = useRef(null);
    const generateUniqueId = UniqueId('user');

    useEffect(() => {
        setSelected(selectedItem);
    }, [selectedItem]);

    // API call only when dropdown opens
    useEffect(() => {
        if (dropdownOpen) {
            // Reset search when dropdown opens
            setSearch("");
            // Load initial data
            loadItems(true, "", 1);
        }
    }, [dropdownOpen]);

    // Handle search after dropdown is open
    useEffect(() => {
        if (dropdownOpen && lastFetchedQuery !== debouncedSearch) {
            loadItems(true, debouncedSearch, 1);
        }
    }, [debouncedSearch]);

    const getLogoText = (name) => {
        if (!name) return "";

        const words = name.trim().split(" ");

        // if only 1 word → return first 2 letters
        if (words.length === 1) {
            return words[0].substring(0, 2).toUpperCase();
        }

        // if multiple words → return first letter of first two words
        return (words[0][0] + words[1][0]).toUpperCase();
    };

    const loadItems = async (reset = false, query = search, nextPage = 1) => {
        if (!reset) setIsLoadingMore(true);

        try {
            const response = await fetchData(query, nextPage, pageSize);
            const newItems = response?.items || [];
            const total = response?.total || 0;

            if (reset) {
                setItems(newItems);
                setDisplayedItems(newItems);
                setPage(1);
                setLastFetchedQuery(query);
            } else {
                setItems(prev => [...prev, ...newItems]);
                setDisplayedItems(prev => [...prev, ...newItems]);
                setPage(nextPage);
            }

            setHasMore((reset ? newItems.length : (page * pageSize + newItems.length)) < total);
        } finally {
            setIsLoadingMore(false);
        }
    };

    const loadMore = () => {
        if (hasMore && !isLoadingMore) {
            const nextPage = page + 1;
            loadItems(false, search, nextPage);
        }
    };

    const handleScroll = () => {
        const el = containerRef.current?.querySelector(".dropdown-list");
        if (el && el.scrollTop + el.clientHeight >= el.scrollHeight - 10) {
            loadMore();
        }
    };

    const handleSelect = (item) => {
        if (disabled) return;
        withState && setSelected(item);
        setDropdownOpen(false);
        onChange && onChange(item);
    };

    // Handle Add New button click - close dropdown and execute action
    const handleAddNew = (e) => {
        e.stopPropagation(); // Prevent event bubbling
        setDropdownOpen(false);
        addButtonAction(e);
    };

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (containerRef.current && !containerRef.current.contains(e.target)) {
                setDropdownOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    const callClearHandler = (event) => {
        event.stopPropagation();
        isClearHandleChange();
    }

    return (
        <div ref={containerRef} style={{ position: "relative", width: "100%" }}>

            <div onClick={() => !disabled && setDropdownOpen(!dropdownOpen)}
                className={`__anvCityDropNw ${error ? "__errorDv" : ""} ${disabled ? "__disabledDv" : ""}  ${inputClass}`}>
                <label
                    style={{
                        position: "absolute",
                        top: dropdownOpen || selected?.label ? -0 : error ? "48%" : "50%",
                        left: 6,
                        fontSize: dropdownOpen || selected?.label ? 12 : 14,
                        color: "#666",
                        background:
                            disabled
                                ? selected?.label
                                    ? '#fff'
                                    : '#f2f2f2'
                                : '#fff',
                        padding: dropdownOpen || selected?.label ? "0 4px" : "0 100px 0px 5px",
                        transform: "translateY(-50%)",
                        transition: "all 0.2s ease",
                        pointerEvents: "none",
                    }}
                >
                    {label}
                </label>
                <span style={{
                    color: selected?.label ? "#000" : "#888",
                    fontSize: 14,
                    flex: 1,
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    paddingRight: "8px",
                    maxWidth: '188px'
                }}>
                    {(selected?.label || placeholder)}
                </span>
                {(isClearOption && !disabled) && (
                    <span className="clear-icon" onClick={(e) => callClearHandler(e)}>
                        <RxCross2 size={20} color="black" />
                    </span>
                )}
                <span style={{
                    flexShrink: 0,
                    display: "flex",
                    alignItems: "center"
                }}>
                    {dropdownOpen ? <IoIosArrowUp /> : <IoIosArrowDown />}
                </span>
            </div>
            {dropdownOpen && !disabled && (
                <div
                    className="dropdown-list"
                    style={{
                        position: "absolute",
                        top: "100%",
                        width: "100%",
                        maxHeight: 250,
                        overflowY: "auto",
                        background: "#fff",
                        border: "1px solid #ccc",
                        borderRadius: 4,
                        zIndex: 1000,
                        marginTop: 4,
                        display: "flex",
                        flexDirection: "column",
                    }}
                    onScroll={handleScroll}
                >
                    <div className="__searchIn_multiBx">
                        <input
                            type="text"
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                            placeholder="Search..."
                            style={{
                                width: "100%",
                                padding: "8px",
                                boxSizing: "border-box",
                                borderBottom: "1px solid #ccc",
                                background: '#fff'
                            }}
                            autoFocus
                        />
                    </div>
                    <div className="__otr_checkBx_fl">
                        {displayedItems.map((item) => {
                            const uniqId = generateUniqueId(item?._id);
                            const displayLabel = item.firm_id?.firm
                                ? (
                                    <div style={{ display: "flex", flexDirection: "column" }}>
                                        <span style={{ fontSize: "14px", fontWeight: "400" }}>{item.label}</span>
                                        <div className="__frmAndComp_mainBx" >

                                            <span
                                                style={{
                                                    fontSize: "11px",
                                                    background: "#e8ecf0",
                                                    color: "#2c3e50",
                                                    padding: "3px 7px",
                                                    borderRadius: "6px",
                                                    width: "fit-content",
                                                    marginTop: "4px",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    gap: "5px"
                                                }}
                                            >
                                                <img src={FirmImg}
                                                    className="firm_icon_img"
                                                    style={{
                                                        filter: "invert(60%) sepia(90%) saturate(900%) hue-rotate(5deg)"
                                                    }}
                                                /> {" "}

                                                {item.firm_id.firm}
                                            </span>
                                        </div>

                                    </div>
                                )
                                : item?.label;

                            return <div
                                key={uniqId}
                                onClick={() => handleSelect(item)}
                                className={`__ctyBar ${selected?._id === item._id ? "select__ctyBar" : ""} `}
                            >
                                {item?.stateName ? `${item?.name}, ${item?.stateName}` : displayLabel}
                            </div>
                        })}
                    </div>

                    {isLoadingMore && (
                        <div style={{ padding: 8, textAlign: "center", fontSize: 12 }}>
                            Loading...
                        </div>
                    )}

                    {displayedItems.length === 0 && !isLoadingMore && (
                        <div style={{ padding: 8, textAlign: "center", fontSize: 12 }}>
                            No Data
                        </div>
                    )}

                    {isAddButton && <div
                        style={{
                            borderTop: "1px solid #ccc",
                            background: "#fff",
                            padding: 5,
                            position: "sticky",
                            bottom: 0,
                            zIndex: 2,
                        }}
                    >
                        <button
                            className="_addNew_cdmBtn"
                            onClick={handleAddNew}
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                viewBox="0 0 18 18"
                                fill="none"
                            >
                                <path
                                    d="M8.61539 0C6.33902 0.0276205 4.16368 0.944178 2.55393 2.55393C0.944178 4.16368 0.0276205 6.33902 0 8.61539C0.0276205 10.8917 0.944178 13.0671 2.55393 14.6768C4.16368 16.2866 6.33902 17.2031 8.61539 17.2308C10.8917 17.2031 13.0671 16.2866 14.6768 14.6768C16.2866 13.0671 17.2031 10.8917 17.2308 8.61539C17.2031 6.33902 16.2866 4.16368 14.6768 2.55393C13.0671 0.944178 10.8917 0.0276205 8.61539 0ZM13.5385 9.23077H9.23077V13.5385H8V9.23077H3.69231V8H8V3.69231H9.23077V8H13.5385V9.23077Z"
                                    fill="#1956F6"
                                />
                            </svg>
                            Add New
                        </button>
                    </div>}
                </div>
            )}

            {error && errorMessage && (
                <div style={{ color: "var(--invailid-color)", fontSize: 12, marginLeft: 3, marginTop: 3, fontWeight: 500 }}>
                    {errorMessage}
                </div>
            )}
        </div>
    );
};

export default CityDropdownForTrip;

